import { j as s } from "../accordion/Accordion-CrPiD_81.mjs";
import "react";
import "../icons/HeartToggle-BHSYQIN4.mjs";
import { S as o } from "../icons/Icons-De2TWMGd.mjs";
import { L as m } from "./ListItem-JIUBy2_m.mjs";
const j = ({ children: t, ...r }) => /* @__PURE__ */ s.jsx(m, { testId: "rds-list-item--cross", icon: /* @__PURE__ */ s.jsx(o, {}), ...r, children: t });
export {
  j as C
};
